import { ControllerRenderProps, FieldValues } from 'react-hook-form';

interface IProps {
    field: ControllerRenderProps<FieldValues, string>;
}

const FormHidden = ({ field }: IProps) => <input type="hidden" id={field.name} {...field} />;

export default FormHidden;
